export enum KycAccountStatusEnum {
	ACTIVE = 'active',
	ACTION_REQUIRED = 'action_required',
	REJECTED = 'rejected',
	ACCOUNT_UPDATED = 'account_updated',
	ACCOUNT_CLOSED = 'account_closed',
	DISABLED = 'disabled',
	SUBMISSION_FAILED = 'submission_failed',
}
